// CHAT-SWITCH-B: the shareable link of a message (Copy link). It names the message only, so it
// still opens after its topic is moved or renamed, however far back it is: `/chat/m/{id}` asks
// the API where it is now (`MessageLinkPage`) and opens its conversation on it.
export function messageHref(slug: string, messageId: string, origin = window.location.origin) {
  return `${origin}/c/${encodeURIComponent(slug)}/chat/m/${encodeURIComponent(messageId)}`;
}
